import { Avatar } from '@mui/material';
import { useEffect, useState } from 'react';
import setUiMessage from '../Utilities/Tostify';
import { post } from './Auths/AuthToken';
import PastAppListPopup from './Schedular/Appointment/PastAppListPopup';
import GroupAppPatPopUp from './Schedular/Appointment/GroupAppPatPopUp';
import { Link } from 'react-router-dom';
import { debounce } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  setGrpApp,
  setGrpAppPats,
} from '../redux/slices/scheduler/appointmentSlice';
import { setSeltSerchPat } from '../redux/slices/patient/patientSlice';
import Button from './Button';

function PatientSerchPopUpForApp({
  handleClosePatSerch,
  multiSelect = false,
  handlePatArr = () => {},
  defaultPat = [],
}) {
  const dispatch = useDispatch();
  const { appPopup, grpApp, grpAppPats,grpAppArivedPats } = useSelector(
    (store) => store.appointment
  );

  const [patDataList, setPatDataList] = useState([]);
  const [groupAppChkBox, setGroupAppChkBox] = useState(false);
  const [grpAppOnAppPopup, setGrpAppOnAppPopup] = useState(false);
  const [pastAppPat, setPastAppPat] = useState(null);
  const [input, setInput] = useState('');
  const [selectedPats, setSelectedPats] = useState(
    defaultPat && defaultPat.length > 0 ? [...defaultPat] : []
  );

  useEffect(() => {
    handlePatArr(selectedPats);
  }, [selectedPats, handlePatArr]);

  useEffect(() => {
    setGroupAppChkBox(grpApp);
    setGrpAppOnAppPopup(grpApp);
  }, [grpApp]);

  useEffect(() => {
    let isCancelled = false;
    const debouncedFetchResults = debounce(async (term) => {
      try {
        const response = await post(
          'api/appointment/appointment/listOfPatient',
          {
            searchStr: input,
            searchCritaria: 'any',
            fname: '',
            mname: '',
            lname: '',
            appMode: '1',
            offset: '0',
          }
        );
        if (!isCancelled && response.status === 200) {
          setPatDataList(response?.data?.patList);
        }
      } catch (err) {
        setUiMessage('suc', err.message);
      } finally {
        //setIsDivHidden(false);
      }
    }, 500);

    if (input.trim() !== '') {
      debouncedFetchResults(input);
    } else {
      setPatDataList([]);
    }
    return () => {
      isCancelled = true;
      debouncedFetchResults.cancel(); // Cancel any pending debounce on cleanup
    };
  }, [input]);

  const handleSelectPatinet = (data) => {
    if (grpApp) {
      if(grpAppArivedPats.includes(data.userId)){
        setUiMessage('inf', 'This patient already arrived in this group.');
        return;
      }
      if (
        grpAppPats.some((o) => parseInt(o.userId) === parseInt(data.userId))
      ) {
        setUiMessage('inf', 'You have already added this patient.');
      } else {
        dispatch(setGrpAppPats(data));
      }
    } else if (multiSelect) {
      if (selectedPats.some((item) => item.userId === data.userId)) {
        setUiMessage('err', 'Patient already added!');
      } else {
        setSelectedPats([...selectedPats, data]);
        setTimeout(() => {
          handleClosePatSerch();
        }, 0);
      }
    } else {
      dispatch(
        setSeltSerchPat({
          patId: data?.userId,
          getPatientType: data?.getPatientType,
          getNewPatientType: data?.getNewPatientType,
          patName: data?.patName,
        })
      );

      handleClosePatSerch();
    }
  };
  const handleGroupApp = (e) => {
    setGroupAppChkBox(e.target.checked);
    dispatch(setGrpApp(e.target.checked));
  };

  const handleGrpAppClosed = () => {
    setGrpAppOnAppPopup(false);
  };

  const handlePastApp = (data) => {
    setPastAppPat(data?.userId);
  };
  return (
    <div className="modalBackground">
      <div className="main-contnr srch-ptnt-popup">
        <div className="flex-sec justify-between item-center">
          <div className="hdr-pt-info flex-sec item-center gap10">
            <div className="clear-left10">Search Patient:</div>
            <div className="" style={{ flexBasis: '40%' }}>
              <input
                type="search"
                className="main-search"
                placeholder="Search Patient..."
                onChange={(e) => setInput(e.target.value)}
                autoFocus
              />
            </div>
            {appPopup && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '10px',
                }}
              >
                <input
                  type="checkbox"
                  checked={groupAppChkBox}
                  onChange={handleGroupApp}
                  style={{ marginRight: '10px' }}
                />
                {grpApp ? (
                  <span onClick={() => setGrpAppOnAppPopup(true)}>
                    <Link>Group Appointment</Link>
                  </span>
                ) : (
                  'Group Appointment'
                )}
              </div>
            )}
            {grpApp && (
              <Button variant="outline" onClick={handleClosePatSerch}>
                Done
              </Button>
            )}
          </div>

          <Button variant="circle" onClick={handleClosePatSerch}>
            X
          </Button>
        </div>
        {grpAppOnAppPopup && (
          <GroupAppPatPopUp
            handleGrpAppClose={handleGrpAppClosed}
            styles={{ right: '0' }}
          />
        )}
        <div className="patient-list-hdr">
          <div className="ptnt-lst-hdr-lbl pcol-1">
            <span className="bold">Name</span>
          </div>
          <div className="ptnt-lst-hdr-lbl pcol-6">
            <span className="bold">Last Visit</span>
          </div>
          <div className="ptnt-lst-hdr-lbl pcol-7">
            <span className="bold">Next Appt.</span>
          </div>
          <div className="ptnt-lst-hdr-lbl pcol-8">Appt</div>
          <div className="ptnt-lst-hdr-lbl pcol-9">
            <span className="bold">Payor</span>
          </div>
          <div className="ptnt-lst-hdr-lbl pcol-5">Contact</div>
        </div>
        <div className="main-contnr-bdy alt-rw-fff">
          {patDataList &&
            patDataList.map((data, idx) => {
              let altClr = idx % 2 === 1 ? 'alt-rw' : '';
              return (
                <div
                  key={idx}
                  className={`${
                    multiSelect
                      ? selectedPats.some((obj) => obj.userId === data.userId)
                        ? `patient-list-bdy-rw pat-rec-selected`
                        : `patient-list-bdy-rw ${altClr}`
                      : grpAppPats.some((obj) => obj.userId === data.userId)
                      ? `patient-list-bdy-rw pat-rec-selected`
                      : `patient-list-bdy-rw ${altClr}`
                  }`}
                >
                  <div
                    className="ptnt-lst-hdr-lbl grid-sec pcol-1"
                    onClick={() => handleSelectPatinet(data)}
                  >
                    <span className="bold link-color">
                      {data?.patName} {data?.age} [
                      {data?.gender.toUpperCase().substr(0, 1)}]
                    </span>
                    <span className="">DOB: {data?.dob}</span>
                    <span className="">ID: {data?.chart_number} </span>
                  </div>
                  <div
                    className="ptnt-lst-hdr-lbl grid-sec pcol-6"
                    onClick={() => handleSelectPatinet(data)}
                  >
                    <span className="">{data?.lastVisDt}</span>
                    <span className="maroon">{data?.lastVisTov}</span>
                    <span className="">{data?.lastAppResName}</span>
                  </div>
                  <div className="ptnt-lst-hdr-lbl grid-sec pcol-7">
                    <span className="">
                      {data?.nextAppDt}
                      {/* | {data?.nextAppTime} */}
                    </span>
                    <span className="maroon">{data?.nextAppTov}</span>
                    <span className="">{data?.nextAppResName}</span>
                  </div>
                  <div className="ptnt-lst-hdr-lbl grid-sec pcol-8">
                    <span className="" onClick={() => handlePastApp(data)}>
                      <Avatar alt="" src={'./images/History.png'} />
                    </span>
                  </div>
                  <div
                    className="ptnt-lst-hdr-lbl grid-sec pcol-9"
                    onClick={() => handleSelectPatinet(data)}
                  >
                    <span className="">{data?.payor}</span>
                    <span className="">Payor Bal: {data?.payorBal}</span>
                    <span className="">
                      Patient Bal: <span className="red">{data?.patBal}</span>
                    </span>
                  </div>
                  <div
                    className="ptnt-lst-hdr-lbl grid-sec pcol-5"
                    onClick={() => handleSelectPatinet(data)}
                  >
                    <span className="">M: {data?.mobile}</span>
                    <span className="">H: {data?.home_phone}</span>
                    <span className="">{data?.email}</span>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      {pastAppPat && (
        <PastAppListPopup
          patientId={pastAppPat}
          setPastAppListPopup={() => setPastAppPat(null)}
          hideFutreApp={true}
        />
      )}
    </div>
  );
}

export default PatientSerchPopUpForApp;
